import { render } from "./elcSgnComp.vue?vue&type=template&id=b968f4f0"
import script from "./elcSgnComp.vue?vue&type=script&lang=js"
export * from "./elcSgnComp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__